import Utils from '../util/Utils';
import Toastr from "../util/Toastr";

export default class ReportingCtrl {
  constructor(ReportingService) {
    this.ReportingService = ReportingService;

    this.allDataProviderPairs = [];
    this.supplierPairs = [];
    this.quartersFormat = [];
    this.dataProviderPairs = [];
    this.dateFrom = null;
    this.dateTo = null;
    this.typm = 'all';
    this.opmType = 'all';
    this.dataType = 'all';
    this.dataPeriod = 'hourly';
    this.profileRole = 'a'
    this.energyType = 'ee';
    this.language = 'CS';
    this.note = '';
    this.extUis = null;
    this.supplierCode = null;
    this.dataProviderCode = null;
    this.allSupplierPairs = [];
    this.enabledProfileRole = true;
    this.enabledHourlyPeriod = false;
    this.enabled15MinutePeriod = false;
    this.enabledDailyPeriod = false;
    this.queueSize = null;

    const self = this;

    this.ReportingService.getQueueSize().then(value => this.queueSize = value);
    this.timer = setInterval(() => {
      this.ReportingService.getQueueSize().then(value => this.queueSize = value);
    }, 30000);

    this.ReportingService.load().then(function (resp) {
      self.allSupplierPairs = resp.supplierPairs;
      self.allDataProviderPairs = resp.dataProviderPairs;
      self.quartersFormat = resp.quartersFormat;
      self.changeEnergyType();
    });
  }

  check15MinutesInterval() {
    if(this.quartersFormat[this.energyType]) {
      this.enabled15MinutePeriod = true;
    } else {
      this.enabled15MinutePeriod = false;
      this.dataPeriod = 'hourly';
    }
  }

  changeEnergyType() {
    this.supplierPairs = this.allSupplierPairs[this.energyType];
    this.dataProviderPairs = this.allDataProviderPairs[this.energyType];
    this.checkEnabledProfileRole();
    if(this.energyType === 'ee') {
      this.enabledHourlyPeriod = true;
      this.enabledDailyPeriod = false;
      this.check15MinutesInterval();
    } else {
      this.enabled15MinutePeriod = false;
      this.enabledHourlyPeriod = false;
      this.enabledDailyPeriod = true;
    }
  }

  changeTypM() {
    // profil „S“ nemá C4 dáta, pri type merania s C4 sa vráti na profil „A“
    if(this.typm === 'all' && this.profileRole === 's') {
      this.profileRole = 'a';
    }
    this.checkEnabledProfileRole();
  }

  changeProfileRole() {
    // profil „S“ nemá C4 dáta, preto pri ňom typ merania s C4 nedáva zmysel
    if(this.profileRole === 's' && this.typm === 'all') {
      this.typm = 'AB';
    }
  }

  checkEnabledProfileRole() {
    if(this.energyType === 'ee') {
      if(this.typm === 'C') {
        this.enabledProfileRole = false;
        // profil sa pre C4 neponúka, nesmie ostať zvolený „S“ z predchádzajúceho výberu
        this.profileRole = 'a';
      } else {
        this.enabledProfileRole = true;
      }
    } else {
      this.enabledProfileRole = false;
    }
  }

  exportOpm() {
    this.ReportingService.exportOpm(
      this.dateFrom ? Utils.getDate(this.dateFrom) : null,
      this.dateTo ? Utils.getDate(this.dateTo) : null,
      this.energyType,
      this.language,
      this.extUis,
    );
  }

  exportMeasurement() {
    if(!this.dateFrom || !this.dateTo) {
      Toastr.notify('Pole "Dátum od/do" musí být vyplněno.', "danger");
      return;
    }
    if(this.quartersFormat[this.energyType]) {
      var date = new Date(this.quartersFormat[this.energyType]);
      if(date > this.dateFrom && date < this.dateTo) {
        Toastr.notify('Nelze vygenerovat report přes změnu struktury dat: ' + date.toLocaleDateString("sk-SK"), "danger");
        return;
      }
    }
    this.ReportingService.exportMeasurement(
      Utils.getDate(this.dateFrom),
      Utils.getDate(this.dateTo),
      this.energyType,
      this.language,
      this.typm,
      this.profileRole,
      this.opmType,
      this.dataType,
      this.dataPeriod,
      this.supplierCode,
      this.dataProviderCode,
      this.extUis,
      this.note
    );
  }
}



// WEBPACK FOOTER //
// ./src/Reporting/ReportingCtrl.js